import { defineStore, acceptHMRUpdate } from "pinia";
import { useArchivalFiltersStore } from "./archivalFilters";

/**
 * Store do obsługi kroków (stepów) w module archiwalnych pomiarów pojazdów.
 * Umożliwia przechodzenie po krokach kreatora (filtry, wyniki itd.)
 * oraz trzyma flagę czy jesteśmy na ekranie wyników.
 */
export const useArchivalStore = defineStore({
  id: "archival",
  state: () => ({
    step: 1,       // Aktualny krok w kreatorze (np. 1 = filtry, 2 = kolejne, 4 = wyniki)
    isResult: false, // Czy aktualnie pokazujemy wyniki (true tylko na ostatnim kroku)
  }),
  actions: {
    /**
     * Ustawia flagę czy pokazujemy wyniki (isResult)
     * @param {boolean} value
     */
    setResultState(value) {
      this.isResult = value;
    },

    /**
     * Przechodzi do kolejnego kroku kreatora.
     * Przed przejściem sprawdza czy wymagane dane zostały podane.
     * Po przejściu na krok 4 ustawia isResult na true, jeśli dane są poprawne.
     * Zawsze korzysta z walidacji w filtersStore (useArchivalFiltersStore).
     */
    nextStep() {
      const filtersStore = useArchivalFiltersStore();
      if (this.step === 1) {
        filtersStore.checkRequireData1(true); // Sprawdzenie wymaganych danych (np. daty, lokalizacja)
        if (filtersStore.error) {
          this.step = 1;
          this.isResult = false;
        } else {
          this.step++;
        }
      } else if (this.step < 4) {
        this.step++;
      }
      if (this.step === 4) {
        filtersStore.checkRequireData(); // Sprawdzamy jeszcze raz przy finalnym kroku
        if (filtersStore.error) {
          this.step = 1;
          this.isResult = false;
        } else {
          this.isResult = true;
        }
      }
      return this.step;
    },

    /**
     * Wróć do poprzedniego kroku
     */
    previousStep() {
      if (this.step > 1) {
        this.step--;
      }
      return this.step;
    },

    /**
     * Resetuje kreator do początku
     */
    clear() {
      this.step = 1;
      this.isResult = false;
    },
  },
});

// Obsługa hot-reload w dev
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useArchivalStore, import.meta.hot));
}
